import apiClient from './api';

export interface Order {
  id: string;
  itemReference: {
    itemId?: string;
    name: string;
    compartment?: string;
  };
  quantity: number;
  location: string;
  status: 'pending' | 'ordered' | 'delivered' | 'approved' | 'cancelled';
  requestedBy: string;
  requester?: {
    username: string;
  };
  requestDate: string;
  completedDate?: string;
  notes?: string;
  instanceIdentifier?: string | null;
}

export interface CreateOrderData {
  itemReference: {
    itemId?: string;
    name: string;
    compartment?: string;
  };
  quantity: number;
  location: string;
  notes?: string;
  instanceIdentifier?: string;
}

export const orderService = {
  getOrders: async (status?: string): Promise<Order[]> => {
    const params = status ? { status } : {};
    const response = await apiClient.get('/orders', { params });
    return response.data;
  },

  getMyOrders: async (): Promise<Order[]> => {
    const response = await apiClient.get('/orders/my-orders');
    return response.data;
  },

  createOrder: async (data: CreateOrderData): Promise<Order> => {
    const response = await apiClient.post('/orders', data);
    return response.data;
  },

  updateOrderStatus: async (id: string, status: string): Promise<Order> => {
    const response = await apiClient.patch(`/orders/${id}/status`, { status });
    return response.data;
  },

  updateOrderQuantity: async (id: string, quantity: number): Promise<Order> => {
    const response = await apiClient.patch(`/orders/${id}/quantity`, { quantity });
    return response.data;
  },

  deleteOrder: async (id: string): Promise<void> => {
    await apiClient.delete(`/orders/${id}`);
  },
};
